module.exports = __webpack_public_path__ + "static/DM02-254a61175f16bc03d657485f12462d64.jpg";